@if (creating()) {
<mb-brand-products-create (productAdded)="onCreated($event)" (close)="cancelCreate()" />
} @else {
<div class="sb-products">
    <p class="sb-products-q">Which product?</p>

    @if (loading()) {
    <p class="sb-products-status">Loading your products</p>
    }

    <div class="sb-products-list">
        @for (product of products(); track product.id) {
        <button type="button" class="sb-product" (click)="choose(product)">
            <span class="sb-product-thumb" aria-hidden="true">
                @if (product.productImage) {
                <img [src]="imageService.getImageSource(product.productImage, 'gallery')" alt="" />
                } @else {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-linecap="round" stroke-linejoin="round">
                    <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                    <circle cx="9" cy="9" r="2" />
                    <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
                </svg>
                }
            </span>
            <span class="sb-product-tx">
                <span class="sb-product-t">{{ product.productName }}</span>
                @if (product.productDescription) {
                <span class="sb-product-d">{{ product.productDescription }}</span>
                }
            </span>
            @if (price(product)) {
            <span class="sb-product-price">{{ price(product) }}</span>
            }
            <svg class="sb-product-chev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="m9 18 6-6-6-6" />
            </svg>
        </button>
        }

        <button type="button" class="sb-product sb-product-new" (click)="startCreate()">
            <span class="sb-product-thumb sb-product-plus" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                    <path d="M12 5v14" />
                </svg>
            </span>
            <span class="sb-product-tx">
                <span class="sb-product-t">New product</span>
                <span class="sb-product-d">Add a product that isn't in your catalogue yet</span>
            </span>
            <svg class="sb-product-chev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="m9 18 6-6-6-6" />
            </svg>
        </button>
    </div>
</div>
}
